var React = require('react');

function CorrectMark (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.812256","y":"0.782227","width":"124.987","height":"124.462","rx":"62.231","fill":"#33D5B5","key":0}),React.createElement("path",{"d":"M39.0557 63.014L55.2223 79.3473L87.5557 46.6807","stroke":"#FCFCFD","strokeWidth":"7","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CorrectMark.defaultProps = {"width":"126","height":"126","viewBox":"0 0 126 126","fill":"none"};

module.exports = CorrectMark;

CorrectMark.default = CorrectMark;
